import PropTypes from 'prop-types'
import React, { useState, useRef, useEffect } from 'react'
import useError from '../hooks/useError'
import useWarning from '../hooks/useWarning'

// eslint-disable-next-line no-unused-vars
const InputEditable = React.forwardRef((props, ref) => {
  const {
    name,
    classLabel,
    classInput,
    disabled,
    texto,
    placeholder,
    onChange,
    onClickOutSide,
    onFocus,
    onFocusSelected,
    errores,
    warnings,
    ...rest
  } = props
  const { ShowError, hayError } = useError(errores, name)
  const { ShowWarning, hayWarning } = useWarning(warnings, name)

  const handleFocus = (event) => onFocusSelected && event.target.select()

  const obtenerClases = () => {
    const classes = []
    if (classInput) {
      classes.push(classInput)
    }
    if (disabled) {
      classes.push('disabled')
    }
    if (hayError) {
      classes.push('error')
    }
    if (hayWarning) {
      classes.push('warning')
    }
    return classes.join(' ')
  }

  const inputRef = useRef(null)
  const [inputVisible, setInputVisible] = useState(false)
  const [text, setText] = useState(texto)

  function handleClickOutSide(e) {
    if (inputRef.current && !inputRef.current.contains(e.target)) {
      onClickOutSide(e, name)

      setInputVisible(false)
    }
  }

  useEffect(() => {
    if (inputVisible) {
      document.addEventListener('mousedown', handleClickOutSide)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutSide)
    }
  })

  useEffect(() => {
    setText(texto)
  }, [texto])

  const renderInput = () => {
    let input

    if (inputVisible) {
      input = (
        <input
          {...rest}
          ref={inputRef}
          name={name}
          id={name}
          value={text}
          placeholder={placeholder}
          onChange={(e) => {
            onChange(e.nativeEvent)
          }}
          className={obtenerClases()}
          autoFocus
          disabled={disabled}
          onFocus={onFocus ? onFocus : handleFocus}
          aria-disabled={disabled}
        />
      )
    } else {
      input = (
        <>
          <span onClick={() => setInputVisible(true)} className={classLabel}>
            {text === '' ? placeholder : text}
          </span>
          <ShowError />
          <ShowWarning />
        </>
      )
    }

    return input
  }

  return renderInput()
})

InputEditable.defaultProps = {
  type: 'text'
}

InputEditable.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'email', 'date', 'number', 'password']),
  classLabel: PropTypes.string,
  classInput: PropTypes.string,
  disabled: PropTypes.bool,
  texto: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClickOutSide: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onFocusSelected: PropTypes.bool,
  errores: PropTypes.object,
  warnings: PropTypes.object
}

InputEditable.displayName = 'InputEditable'

export default InputEditable
